import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {
  DuplirajRacuneCommand,
  RacuniClient,
  TipRacuna,
} from '@kodit/core/data-api';
import { AlertService, SharedService } from '@kodit/core/services';
import { DynamicDialogConfig, DynamicDialogRef } from '@kodit/core/shared-ui';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'kodit-dupliraj-racune-form',
  templateUrl: './dupliraj-racune-form.component.html',
  styleUrls: ['./dupliraj-racune-form.component.scss'],
})
export class DuplirajRacuneFormComponent implements OnInit, OnDestroy {
  /** Subscription */
  private _subs: Subscription = new Subscription();

  /** Props */
  racunIds: number[] = [];
  tip: TipRacuna;
  form: FormGroup;

  constructor(
    private _fb: FormBuilder,
    private _dialogRef: DynamicDialogRef,
    private _dialogConfig: DynamicDialogConfig,
    private _client: RacuniClient,
    private _sharedService: SharedService,
    private _alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.racunIds = this._dialogConfig.data.racunIds;
    this.tip = this._dialogConfig.data.tip;

    this.form = this._fb.group({
      datumPrometa: new FormControl(null),
      napomena: new FormControl(null, {
        validators: [Validators.maxLength(2048)],
      }),
    });

    this._subs.add(
      this._dialogRef.onSubmit.subscribe(() => {
        this._dupliraj();
      })
    );
  }

  get vrstaRacunaLabel(): string {
    return this.tip === TipRacuna.PREDRACUN ? 'predračuna' : 'faktura';
  }

  private _dupliraj() {
    if (!this.form.valid) {
      this._alertService.addWarnMsg('Napomena može imati najviše 2048 karaktera.');
      return;
    }

    this._sharedService.displayLoadingScreen(true, 'Pokretanje dupliranja...');
    this._subs.add(
      this._client
        .duplirajMasovno(
          new DuplirajRacuneCommand({
            racunIds: this.racunIds,
            tip: this.tip,
            datumPrometa: this.form.value.datumPrometa ?? undefined,
            napomena: this.form.value.napomena || undefined,
          })
        )
        .pipe(
          finalize(() => {
            this._sharedService.resetLoadingScreen();
          })
        )
        .subscribe((res) => {
          this._alertService.addSuccessMsg(res.data);
          this._dialogRef.close(true);
        })
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}
